import React from 'react';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import styled from 'styled-components';

import { ROUTE_URLS } from '../constants/navigationLinks';

const LogoWrapper = styled(Link)`
  .gatsby-image-wrapper {
    width: var(--width-logo-small);
  }

  img {
    width: 100%;
    height: auto;
    display: block;
  }
`;

const LogoSmall: React.FC = () => {
  return (
    <LogoWrapper to={ROUTE_URLS.home}>
      <StaticImage
        src="../assets/images/logo.svg"
        alt="Mondmau Developments Logo"
        loading="eager"
        placeholder="none"
        width={150}
      />
    </LogoWrapper>
  );
};

export default LogoSmall;
